// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","809":"component---src-pages-index-mdx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"19057d1459c2ca131127","809":"6a0de1c77cf2c02f4a59","883":"5aa0f285278dc37a0b7e"}[chunkId] + ".js";
};